var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTempoTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 24,
    height: 24,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36D896",
    fillRule: "evenodd",
    d: "M0 11.99470825C0 5.37019653 5.37023926.0000183 11.9946289.0000183c6.61962891.01171875 11.98303223 5.37506103 11.99475098 11.99468994 0 6.62445068-5.37023926 11.9946289-11.99475097 11.9946289C5.37023926 23.98933715 0 18.61915893 0 11.99470825zm2.39892578 0c0 5.29956054 4.29614258 9.59570312 9.59570313 9.59570312 5.29589843-.00878906 9.58691406-4.29980468 9.5958252-9.59570312 0-5.29962158-4.29626466-9.59576416-9.5958252-9.59576416-5.29956055 0-9.59570313 4.29614258-9.59570313 9.59576416z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36D896",
    fillRule: "evenodd",
    d: "M13.1994669 5.03509551h-2.3989338v7.46334963l5.02443358 4.99777876 1.69258108-1.70057752-4.31808086-4.29409152V5.03509551z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempoTutorial);
export default __webpack_public_path__ + "static/media/tempo_tutorial.9138ed6b4165455cfe463840a177c501.svg";
export { ForwardRef as ReactComponent };